import { render, staticRenderFns } from "./ArticleStatistics.vue?vue&type=template&id=133c8155&scoped=true"
import script from "./ArticleStatistics.vue?vue&type=script&lang=js"
export * from "./ArticleStatistics.vue?vue&type=script&lang=js"
import style0 from "./ArticleStatistics.vue?vue&type=style&index=0&id=133c8155&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133c8155",
  null
  
)

export default component.exports